export default {
  "0": {
    label: "Неактивный",
    colorBg: "#FFEAE7",
    colorTx: "#E85949",
  },
  "10": {
    label: "Активный",
    colorBg: "#E4FBF1",
    colorTx: "#1CA673",
  },
  "20": {
    label: "Черновик",
    colorBg: "#EBEEF7",
    colorTx: "#566B7D",
  },
  "30": {
    label: "Архив",
    colorBg: "#F9F9F9",
    colorTx: "#566B7D",
  },
}
